import getLang from 'I18n/utils/getLang';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { LongFilterQueryTypename, StringFilterQueryTypename } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { useAppContextQuery } from '../../hooks/useAppContextQuery';
export function useSupportedListingOptions(listingIds) {
  var _searchQueryResult$da, _searchQueryResult$da2;
  const filter = {
    filterGroups: [{
      filtersByField: Object.assign({
        PRODUCT_TYPE: [{
          values: ['APP'],
          negation: false,
          clause: 'OR',
          __typename: StringFilterQueryTypename
        }]
      }, listingIds.length > 0 ? {
        LISTING_ID: [{
          values: listingIds.map(id => Number(id)),
          negation: false,
          clause: 'OR',
          __typename: LongFilterQueryTypename
        }]
      } : {}),
      clause: 'AND',
      negation: false
    }],
    clause: 'AND',
    negation: false
  };
  const searchQueryResult = useAppContextQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      skip: listingIds.length === 0,
      variables: {
        language: getLang(),
        filter
      }
    }
  });
  return ((_searchQueryResult$da = (_searchQueryResult$da2 = searchQueryResult.data) === null || _searchQueryResult$da2 === void 0 ? void 0 : _searchQueryResult$da2.result.cards) !== null && _searchQueryResult$da !== void 0 ? _searchQueryResult$da : []).map(card => ({
    text: card.listingName,
    value: String(card.listingId)
  }));
}